import React, { Suspense } from 'react';
import { Routes, Route} from 'react-router-dom';
import Loader from '@components/Loader';
import SessionExpiredView from '../containers/SessionExpired';

const SessionPageView = React.lazy(() => import('../containers/SessionPage'));
const SessionErrorView = React.lazy(() => import('../containers/SessionError'));
const SessionMainView = React.lazy(() => import('../containers/SessionMain'));


export default function links() {
  return (
    <Suspense fallback={<Loader className="h-screen" />}>
      <Routes>
        {/* Session path */}
        <Route
          path="/"
          element={
            <SessionPageView />
          }
        />
        <Route path="/interview" element={<SessionMainView />} />
        <Route path="/expired" element={<SessionExpiredView />} />
        <Route path="/error" element={<SessionErrorView />} />
      </Routes>
    </Suspense>
  );
}
